export function parseEnvNumber(
  value: string | undefined,
  defaultValue: number = 0,
): number {
  if (!value) return defaultValue;

  const cleaned = value
    ?.toString()
    .trim()
    .replace(/[^\d.-]/g, '');
  const parsed = parseInt(cleaned, 10);

  return isNaN(parsed) ? defaultValue : parsed;
}

export function parseEnvNumberArray(
  value: string | undefined,
  defaultValue: number[] = [],
): number[] {
  if (!value) return defaultValue;

  return value
    .split(',')
    .map(id => {
      const cleanId = id.trim().replace(/["']/g, '');
      const parsedId = parseInt(cleanId, 10);
      return parsedId;
    })
    .filter(id => !isNaN(id));
}

export function parseEnvStringArray(
  value: string | undefined,
  defaultValue: string[] = [],
): string[] {
  if (!value) return defaultValue;

  return value
    .split(',')
    .map(slug => slug.trim().replace(/["']/g, ''))
    .filter(slug => slug.length > 0);
}
